import React from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from 'src/components/triviaGame/Dashboard';
import HolidayCard2022 from '../components/holidays/HolidayCard2022';
import HolidayCard2023 from '../components/holidays/HolidayCard2023';
import InvalidYear from '../components/holidays/InvalidYear';
import TriviaGame from '../components/triviaGame/TriviaGame';

export default function HolidayCardPage() {
  const { year } = useParams();

  switch (year) {
    case "2024":
      return <TriviaGame />;
    case "2023":
      return <HolidayCard2023 />;
    case "2022":
      return <HolidayCard2022 />;
    case "stats":
      return <Dashboard />
    default:
      return <InvalidYear />;
  }
}
